import { useEffect, useState } from "react";
import { Container, Typography, Box, Button, Tab } from "@mui/material";
import FelixAnalytics from "../../../felixAnalytics";
import { useUsuario } from "../../../providers/usuarioProvider";
import {
  IconArrowLeft,
  IconDownload,
  IconReceiptTax,
} from "@tabler/icons-react";
import moment from "moment";
import Imposto from "../../../models/imposto";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { onSnapshot } from "firebase/firestore";
import ImpostoDb from "../../../db/impostoDb";
import Functions from "../../../callable/functions";
import { saveAs } from "file-saver";
import { LoadingButton, TabContext, TabList, TabPanel } from "@mui/lab";
import ImpostoTab from "./impostoTab";
import PosicaoTab from "./posicaoTab";
import ResultadoTab from "./resultadoTab";
import { Link } from "react-router-dom";

export default function DetalhesMes() {
  const { impostoId } = useParams();
  const navigate = useNavigate();
  const { visualizado } = useUsuario();
  const [imposto, setImposto] = useState<Imposto>();
  const [gerandoRelatorio, setGerandoRelatorio] = useState(false);
  const [tab, setTab] = useState("imposto");
  const location = useLocation();
  const ultimoDiaDoMes = imposto?.dataBase.isSame(
    imposto?.dataBase.clone().endOf("month"),
    "day"
  );

  useEffect(() => {
    if (!!location.hash) setTab(location.hash.slice(1));
  }, []);

  useEffect(() => {
    if (!!visualizado && !!impostoId) {
      FelixAnalytics.identify(visualizado);
      FelixAnalytics.track("pageview", { pagina: "fechamento" });
      return onSnapshot(
        new ImpostoDb().doc({ usuarioId: visualizado, impostoId }),
        (snapshot) => {
          if (snapshot.exists()) setImposto(snapshot.data());
        }
      );
    }
  }, [visualizado, impostoId]);

  return (
    <Container
      maxWidth="lg"
      sx={{
        px: 8,
        pt: 2,
        pb: 8,
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Box flexGrow={1}>
          <Typography variant="eyebrow" color="text.secondary">
            Fechamento
          </Typography>
          {/* Competência em itálico accent — assinatura de headline da marca. */}
          <Typography variant="h1" color="text.primary" pt={0.5} gutterBottom>
            {`Detalhes do Controle Fiscal  ${
              ultimoDiaDoMes ? "" : "parcial "
            }de `}
            <Box component="em" sx={{ color: "accentInk" }}>
              {moment(impostoId).endOf("month").format("MMMM [de] YYYY")}
            </Box>
          </Typography>
        </Box>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => navigate(-1)}
          startIcon={<IconArrowLeft />}
        >
          Voltar
        </Button>
        <Box m={1 / 2} />
        <Button
          disabled={
            !(
              !!imposto &&
              ultimoDiaDoMes &&
              imposto.darf &&
              imposto.darf.impostoDevido > 0
            )
          }
          variant="outlined"
          color="primary"
          startIcon={<IconReceiptTax />}
          component={Link}
          to={"/timeline/darf"}
          state={{
            mes: impostoId,
            valorDarf: imposto?.darf?.impostoDevido,
            codigoDarf: "6015",
          }}
        >
          DARF
        </Button>
        <Box m={1 / 2} />
        <LoadingButton
          disabled={!(!!imposto && ultimoDiaDoMes)}
          loadingPosition="start"
          loading={gerandoRelatorio}
          onClick={() => {
            if (!!imposto?.dataBase) {
              setGerandoRelatorio(true);
              new Functions()
                .controleFiscal({ data: imposto?.dataBase.format() })
                .then(({ data: url }) => {
                  saveAs(url);
                })
                .finally(() => setGerandoRelatorio(false));
            }
          }}
          startIcon={<IconDownload />}
          variant="contained"
          color="primary"
        >
          Baixar Relatório
        </LoadingButton>
      </Box>
      {!!visualizado && !!imposto ? (
        <TabContext value={tab}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={(_event, newValue) => {
                setTab(newValue);
                navigate(`${location.pathname}#${newValue}`, { replace: true });
              }}
              // Aba ativa e indicador usam accent-ink: o accent sólido reprova
              // em contraste sobre superfície escura.
              sx={{
                "& .MuiTabs-indicator": { backgroundColor: "accentInk" },
                "& .MuiTab-root.Mui-selected": { color: "accentInk" },
              }}
            >
              <Tab label="Imposto" value="imposto" />
              <Tab label="Resultado" value="resultado" />
              <Tab label="Posição" value="posicao" />
            </TabList>
          </Box>
          <TabPanel value="imposto">
            <ImpostoTab usuarioId={visualizado} imposto={imposto} />
          </TabPanel>
          <TabPanel value="resultado">
            <ResultadoTab usuarioId={visualizado} imposto={imposto} />
          </TabPanel>
          <TabPanel value="posicao">
            <PosicaoTab usuarioId={visualizado} imposto={imposto} />
          </TabPanel>
        </TabContext>
      ) : (
        <></>
      )}
    </Container>
  );
}
